import { Row, Col } from "react-bootstrap";
import Searchhome from "./Search";
import Category from "./Category";
import FeaturedEvent from "./FeaturedEvent";
import ChooseUs from "./ChooseUs";
import City from "./City";
import Counts from "./Counts";
import LatestBlog from "./LatestBlog";
import Sponsors from "./Sponser";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { Box } from "@mui/material";

const WebsiteHomePage = () => {
  const tablet = useMediaQuery({ query: "(max-width: 992px)" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box
        className="auth-main-wrapper sign-in-area"
        sx={{
          width: "100%",                      
          minHeight: "100vh",                 
          display: "flex",
          flexDirection: "column",            
          alignItems: "stretch",             
          justifyContent: "flex-start",
          margin: 0,                          // Remove any margin
          padding: 0,                         // Remove padding from container
          fontFamily: "var(--theme-font-family, inherit)",
        }}
      >
        <div style={{ padding: "0px", width: "100%" }}>
          <Searchhome />
        </div>

        <div className="pading150" style={{ backgroundColor: "var(--section-bg, #EAF0F5)", width: "100%" }}>
          <Category />
        </div>

        <div style={{ backgroundColor: "var(--section-alt-bg, #DFE7ED)", width: "100%" }}>
          <FeaturedEvent />
        </div>

        <div className="pading150" style={{ width: "100%" }}>
          <ChooseUs />
        </div>

        <div style={{ backgroundColor: "var(--footer-bg, #0D263C)", width: "100%" }}>
          <City />
        </div>

        <div className="pading150" style={{ backgroundColor: "var(--accent-color, #EC6325)", width: "100%" }}>
          <Counts />
        </div>

        {/* <div className={tablet ? "" : "pading150"} style={{ backgroundColor: "#DFE7ED", width: "100%" }}>
          <LatestBlog />
        </div> */}

        <div className="" style={{ backgroundColor: "var(--section-bg, #EAF0F5)", width: "100%" }}>
          <Sponsors />
        </div>
      </Box>
    </>
  );
};

export default WebsiteHomePage;